import script from "./FormHelpText.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormHelpText.vue?vue&type=script&lang=ts&setup=true"

import "./FormHelpText.vue?vue&type=style&index=0&id=f663dd46&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f663dd46"]])

export default __exports__